import { httpGet } from './api.service';
import { PairingInfo } from '../types/PairingInfo';
import { SingleResult } from '../types/SingleResult';
import { Result } from '../types/Result';
import { EquipmentPairing } from '../types/EquipmentPairing';

const getPairingInfoByEquipmentId = async (equipmentId: string): Promise<SingleResult<PairingInfo>> =>
  await httpGet<SingleResult<PairingInfo>>(`api/pairing/equipment?equipmentId=${equipmentId}`);

const getPairingInfoByDeviceId = async (deviceId: string): Promise<SingleResult<PairingInfo>> =>
  await httpGet<SingleResult<PairingInfo>>(`api/pairing/device/${deviceId}`);

const getEquipmentPairingInfo = async (id: string): Promise<SingleResult<PairingInfo>> =>
  await httpGet<SingleResult<PairingInfo>>(`api/pairing/equipment?equipmentId=${id}`);

const getPairingHistoryByDeviceId = async (id): Promise<Result<EquipmentPairing>> =>
  await httpGet<Result<EquipmentPairing>>('api/pairing/history?deviceId=' + id);
const getPairingHistoryByEquipmentId = async (id): Promise<Result<EquipmentPairing>> =>
  await httpGet<Result<EquipmentPairing>>('api/pairing/history?equipmentId=' + id);

export {
  getPairingInfoByEquipmentId,
  getPairingInfoByDeviceId,
  getEquipmentPairingInfo,
  getPairingHistoryByDeviceId,
  getPairingHistoryByEquipmentId,
};
